import { Reveal } from "@/components/landing/Reveal";
import { WaitlistForm } from "@/components/landing/WaitlistForm";

export const FinalCTA = () => {
  return (
    <section data-testid="start" id="start" className="relative overflow-hidden py-32">
      <div className="pointer-events-none absolute -left-32 top-1/2 -z-10 h-[480px] w-[480px] -translate-y-1/2 glow-violet blur-3xl" />
      <div className="pointer-events-none absolute -right-32 top-1/2 -z-10 h-[480px] w-[480px] -translate-y-1/2 glow-orange blur-3xl" />
      <div className="mx-auto max-w-4xl px-6 text-center lg:px-8">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gradient">
            Success isn&rsquo;t built in one day. It&rsquo;s built every day.
          </p>
          <h2 className="mt-6 font-mega text-5xl leading-[0.9] text-white sm:text-7xl lg:text-8xl">
            Ready to Become
            <br />
            <span className="text-gradient">Who You&rsquo;re Meant to Be?</span>
          </h2>
          <p className="mx-auto mt-7 max-w-xl text-lg text-muted-foreground">
            The life you want isn&rsquo;t out of reach. It starts with one decision, one
            goal, one step &mdash; and one AI committed to helping you succeed.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-11 flex flex-col items-center">
          <WaitlistForm testid="final-waitlist" />
          <p className="mt-4 text-sm text-muted-foreground">
            Early access dropping soon. No spam, one email when we open the doors.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
